<p>All uploaded files in this flow will be committed into document management with their associated tags</p>
<div class="grid-x">
  <div class="cell small-12">
    Get Organization Data from:
  </div>
  @for ( opt of organizationOptions; track  opt) {
    <div class="cell small-12">
      <input type="radio" name="organization" [(ngModel)]="organizationSource" [value]="opt.id" /> {{opt.text}}
    </div>
  }
</div>
@if (organizationSource === 'context') {
  <div class="grid-x">
    <div class="cell small-6">
      Organization ID Context:
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="organizationIdContext" />
    </div>
    <div class="cell small-6">
      Organization Name Context:
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="organizationNameContext" />
    </div>
  </div>
}